import _typeof from "E:/wnmp/www/ycf_m/static/mmm-cli/node_modules/@babel/runtime/helpers/esm/typeof.js";
/* eslint-disable no-param-reassign */
import Vue from 'vue';
import loading from "./index.vue";
var LoadingConstructor = Vue.extend(loading);
var createInstance = function createInstance(data) {
  if (_typeof(data) !== 'object') {
    data = {
      message: data
    };
  }
  return new LoadingConstructor({
    el: document.createElement('div'),
    data: data
  });
};
loading.install = function (_Vue) {
  var instance = createInstance();
  _Vue.prototype.$showLoading = function (message, color) {
    if (message) {
      instance.message = message;
    }
    if (color) {
      instance.color = color;
    }
    document.body.append(instance.$el);
  };
  _Vue.prototype.$hideLoading = function () {
    if (instance.$el) {
      document.body.removeChild(instance.$el);
    }
  };
};
export default loading;